import React, { createContext, useState, useMemo, useEffect } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Cookies from 'js-cookie';
import logoLight from '../../assets/images/aiforhrhub-light.png';
import logoDark from '../../assets/images/aiforhrhub.png';
import '@fontsource/karla';

export const ThemeContext = createContext();

const lightTheme = createTheme({
    typography: {
        fontFamily: 'Karla, Arial, sans-serif',
      },
  palette: {
    mode: 'light',
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
    text: {
      primary: '#000',
    },
    appbar: {
      backgroundColor: 'white',
    },
    logo: logoDark,
  },
});

const darkTheme = createTheme({
    typography: {
        fontFamily: 'Karla, Arial, sans-serif',
      },
  palette: {
    mode: 'dark',
    background: {
      default: '#1A223F',
      paper: '#1A223F',
    },
    text: {
      primary: '#fff',
    },
    appbar: {
      backgroundColor: '#111936',
    },
    logo: logoLight,
  },
});

export function ThemeContextProvider({ children }) {
  // Load the initial theme mode from the cookie or default to 'light'
  const [themeMode, setThemeMode] = useState(Cookies.get('themeMode') || 'light');

  const theme = useMemo(() => (themeMode === 'light' ? lightTheme : darkTheme), [themeMode]);

  const toggleTheme = () => {
    const newMode = themeMode === 'light' ? 'dark' : 'light';
    setThemeMode(newMode);
    Cookies.set('themeMode', newMode, { expires: 365 }); // Save to cookie for 1 year
  };

  useEffect(() => {
    // Load theme mode from cookie on first render
    const savedTheme = Cookies.get('themeMode');
    if (savedTheme) {
      setThemeMode(savedTheme);
    }
  }, []);

  return (
    <ThemeContext.Provider value={{ themeMode, toggleTheme }}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
}
